export default __webpack_public_path__ + "static/media/Pc1.5d65051b.jpg";